const desktopHead = document.getElementById('WI_desktopHeader');
const logoSvgPath = desktopHead.querySelector(".WI_desktopHeader_logo").getElementsByTagName("path");
const cartSvgPath = desktopHead.querySelector(".WI_desktopHeader_cart").getElementsByTagName("path");
const cartSvgCircle = desktopHead.querySelector(".WI_desktopHeader_cart").getElementsByTagName("circle");
const headerNavA = document.getElementsByClassName('mainLI_a');
const searchUpsell = document.querySelector('.WI_search_upsell');
const searchInput = document.getElementById('Search');
const searchNumber = document.getElementById('WI_result_number');
const searchClean = document.getElementById('input_clear');
const searchOpenBth = document.getElementsByClassName('WI_saerch_btn');
const searchCloseBth = document.getElementById('WI_search_close');
const searchBody = document.getElementById('WI_saerch_main');
const svgColor = document.querySelectorAll('.svgWhite');
const logoColor = document.querySelector('.logoWhite').querySelectorAll('path');
const menuColor = document.querySelectorAll('.WI_mobileHeader_menu .line');
const mobileMenuOpen = document.getElementById('WI_mobileHeader_menu');
const mobileMenuClose = document.getElementById('WI_mobileMenu_close');
const mobileMenuBody = document.getElementById('WI_mobileMenu_main');
const mobileMenuIn = document.getElementById('WI_mobileMenu_in');
const mobileLI = document.querySelectorAll('.activeLI');
const mobileQuickOptionBody = document.getElementById('WI_mobileQoptions_main');
const mobileQuickOptionClose = document.querySelector('.WI_mobileQoptions_close');
const collectionMain = document.getElementById('WI_collection_main');
const collectionFilterForm = document.getElementById('WI_collectionFilter_form');
const collectionFormSubmit = document.getElementById('WI_collectionFilter_submit');
var filterInput = document.querySelectorAll('.filterInput');
const collectionFilterBody = document.getElementById('WI_collectionFilter_main');
const collectionFilterDrawer = document.getElementById('WI_colletionFilter_drawer');
const collectionFilterHead = document.querySelector('.WI_collection_filter');
const collectionFilterOpenBtn = document.getElementById('WI_collection_filterBtn');
const collectionFilterCloseBtn = document.getElementById('WI_collectionFilter_closeBtn');
const collectionUL = document.getElementById('WI_collectionUL');
const collectionLoadBtn = document.getElementById('collectionLoadBtn');
const productMain = document.getElementById('WI_mainProduct_main');
// Header 
//^^ Header on scroll 
let lastScrollTop = 0;
let headerSvgBlacked = false;
let headerSvgWhite = false;
// window.addEventListener('scroll', () => {
//     const scrollTop = window.scrollY || document.documentElement.scrollTop;
//     if (scrollTop < 400) {
//         desktopHead.style.backgroundColor = "rgba(255,255,255,0)";
//         headerSvgColorWhite();
//     }
//     if (scrollTop > lastScrollTop && scrollTop > 500) {
//         desktopHead.style.transform = 'translateY(-100%)';
//         //^^ For collection filter sticky position
//         if (collectionFilterHead != null) {
//             document.querySelector('.WI_collection_filter').style.top = "0";
//         }
//         setTimeout(() => {
//             desktopHead.style.backgroundColor = "rgba(255,255,255,1)";
//             headerSvgColorBlack();
//         }, 100);
//     } else {
//         desktopHead.style.transform = 'translateY(0)';
//         //^^ For collection filter sticky position
//         if (collectionFilterHead != null) {
//             document.querySelector('.WI_collection_filter').style.top = "59px";
//         }
//     }
//     lastScrollTop = scrollTop;
// });
// //^^ function for changing header svg color
// function headerSvgColorBlack() {
//     if (headerSvgBlacked == false) {
//         forEachFunctionStroke(svgColor, '#000');
//         forEachFunctionFill(logoColor, '#000');
//         forEachFunctionMenu(menuColor, '#000');
//         for (let i = 0; i < headerNavA.length; i++) {
//             headerNavA[i].style.color = '#000';
//         }
//         headerSvgBlacked = true;
//         headerSvgWhite = false;
//     }
// };

// function headerSvgColorWhite() {
//     if (headerSvgWhite == false) {
//         forEachFunctionStroke(svgColor, '#fff');
//         forEachFunctionFill(logoColor, '#fff');
//         forEachFunctionMenu(menuColor, '#fff');
//         for (let i = 0; i < headerNavA.length; i++) {
//             headerNavA[i].style.color = '#fff';
//         }
//         headerSvgBlacked = false;
//         headerSvgWhite = true;
//     }
// };
// //^^foreach function to change svg path stroke
// function forEachFunctionStroke(forEachVar, color) {
//     forEachVar.forEach((svg) => {
//         svg.style.stroke = color;
//     })
// };
// //^^foreach function to change svg path fill
// function forEachFunctionFill(forEachVar, color) {
//     forEachVar.forEach((svg) => {
//         svg.style.fill = color;
//     })
// };
// //^^foreach function to change menu div color
// function forEachFunctionMenu(forEachVar, color) {
//     forEachVar.forEach((svg) => {
//         svg.style.backgroundColor = color;
//     })
// };
// //^^Header mouse effect i am not using css :hover
// desktopHead.addEventListener('mouseenter', () => {
//     if (window.scrollY < 400) {
//         desktopHead.style.backgroundColor = 'rgba(255,255,255,1)';
//         headerSvgColorBlack();
//     }
// });
// desktopHead.addEventListener('mouseleave', () => {
//     if (window.scrollY < 400) {
//         desktopHead.style.backgroundColor = 'rgba(255,255,255,0)';
//         headerSvgColorWhite();
//     }
// });

// When hover out of megamenu
const mainLI = document.querySelectorAll('.WI_megaMenuLI');
mainLI.forEach(LI => {
    LI.addEventListener('mouseenter', ()=>{
        document.querySelector('.WI_headerMenuBG').style.display = "block";
        setTimeout(() => {
            document.querySelector('.WI_headerMenuBG_in').classList.add('WI_headerMenuBG_inActive');
            // document.querySelector('.WI_megaMenu_main').classList.add('WI_megaMenuActive');
        });
    });
    LI.addEventListener('mouseleave', ()=>{
        document.querySelector('.WI_headerMenuBG_in').classList.remove('WI_headerMenuBG_inActive');
        // document.querySelector('.WI_megaMenu_main').classList.remove('WI_megaMenuActive');
        setTimeout(() => {
            document.querySelector('.WI_headerMenuBG').style.display = "none";
        }, 200);
    });
});

// Desktop Quick option
//^^Desktop Quick button on click
function quickATCfunction() {
    const quickOptionCon = document.querySelectorAll('.WI_quickOptions_variant_in');

    // Loop over each container
    quickOptionCon.forEach(quickCon => {
        let quickConID = quickCon.getAttribute('data-quickOptionID'); // Use getAttribute for data-* attributes
        let quickConBtns = quickCon.querySelectorAll('.WI_quickOption_atc');
        
        // Loop over each button inside the container
        quickConBtns.forEach(quickBtn => {
            let quickBtnID = quickBtn.getAttribute('data-quickOption-btnID');
            
            // Attach the event listener only if button ID matches container ID
            if (quickBtnID === quickConID) {
                quickBtn.addEventListener('click', async (e) => {
                    e.preventDefault();

                    // Check if the button is already in a loading state to prevent multiple fetches
                    if (quickBtn.dataset.loading === "true") return;
                    quickBtn.dataset.loading = "true"; // Set the loading state to true
                    
                    // Show loading spinner and hide the Add to Cart text
                    quickBtn.querySelector('.WI_quickOption_atc_value').style.display = 'none';
                    quickBtn.querySelector('.WI_quickOption_atc_loading').style.display = 'block';

                    // Get the option title for the Add to Cart conversion
                    let quickBtnTitle = quickBtn.getAttribute('data-optionValue').toLocaleLowerCase().replace(/[^a-zA-Z0-9]/g, '');

                    // Call the function to add to cart with the correct variant
                    await converJsonTovariantATC(quickBtnTitle, quickCon);

                    // Reset the button state once cartDrawerOpen event is fired
                   
                    
                        quickBtn.querySelector('.WI_quickOption_atc_value').style.display = 'block';
                        quickBtn.querySelector('.WI_quickOption_atc_loading').style.display = 'none';
                        quickBtn.dataset.loading = "false"; // Reset loading state
                  
                });
            }
        });
    });

    // Function to convert the product variant JSON and add it to the cart
    async function converJsonTovariantATC(variantTitle, optionCon) {
        let quickOptionMain = optionCon.parentElement.parentElement;
        let quickOptionJson = JSON.parse(quickOptionMain.querySelector('[type="application/json"]').textContent);
        console.log(quickOptionJson);
        
        // Loop through the JSON data to find the matching variant
        for (const obj of quickOptionJson) {
            let jsonTitle = obj.title.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
            if (jsonTitle === variantTitle) {
                let formData = {
                    'items': [{
                        'id': obj.id,
                        'quantity': 1
                    }]
                };
                
                // Add the item to the cart with a single fetch request
                await fetch('/cart/add', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                });

                // Update the cart drawer and open it
                await updateCartDrawer();
                openCartDrawer();

                // Dispatch a custom event to indicate the cart drawer is open
                document.dispatchEvent(new CustomEvent("cartDrawerOpen", { bubbles: true }));
                
                console.log('Add to cart');
                break; // Exit the loop after the first match to prevent redundant fetch calls
            }
        }
    }
}
quickATCfunction();

// Single varaint quick add to cart
document.querySelectorAll('.WI_oneVariantForm').forEach(atcBtn => {
    atcBtn.addEventListener('click', async ()=>{
        // Show loading spinner and hide the Add to Cart text
        atcBtn.querySelector('.WI_oneVariantForm_span').style.display = 'none';
        atcBtn.querySelector('.WI_quickOption_atc_loading').style.display = 'block';
        let varID = atcBtn.getAttribute('data-varid');
        let formData = {
            'items': [{
                'id': varID,
                'quantity': 1
            }]
        };
        try {
            let singleVarATCRes = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                 body: JSON.stringify(formData)
            });
            // Update the cart drawer and open it
            await updateCartDrawer();
            openCartDrawer();
            // hide loading spinner and show the Add to Cart text
        atcBtn.querySelector('.WI_oneVariantForm_span').style.display = 'block';
        atcBtn.querySelector('.WI_quickOption_atc_loading').style.display = 'none';
        } catch (error) {
            console.log('Single varaint quick add to cart error: ' + error);
            
        }
    });
});

// Mobile Quick option
//^^Mobile quick option click
function mobileQuickAdd() {
    const mobileQuickOption = document.querySelectorAll('.WI_quickOptions_bag_mobile');
    mobileQuickOption.forEach((quick) => {
        quick.addEventListener('click', () => {
            let ProductHandle = quick.getAttribute('data-productHandel');
            fetchQuickProduct(ProductHandle);
        })
    });
};
mobileQuickAdd();
//^^Mobile quick option open
function openMobileQuickOption() {
    mobileQuickOptionBody.style.display = "block";
    setTimeout(() => {
        mobileQuickOptionBody.classList.add('addBlur');
        mobileQuickOptionBody.querySelector('.WI_mobileQoptions_in').style.transform = 'translateY(0)';
        mobileQuickOptionBody.querySelector('.WI_mobileQoptions_in').style.opacity = '1';
    }, 10);
}
//^^Mobile quick option close
mobileQuickOptionClose.addEventListener('click', () => {
    mobileQuickOptionBody.classList.remove('addBlur');
    mobileQuickOptionBody.querySelector('.WI_mobileQoptions_in').style.transform = 'translateY(300px)';
    mobileQuickOptionBody.querySelector('.WI_mobileQoptions_in').style.opacity = '0';
    setTimeout(() => {
        mobileQuickOptionBody.style.display = "none";
        document.querySelector('#WI_mobileQoptions_product').innerHTML = "";
    }, 210);
});
//^^ Mobile quick option close when click on body
mobileQuickOptionBody.addEventListener('click', (e)=>{
    mobileQuickOptionBody.classList.remove('addBlur');
    mobileQuickOptionBody.querySelector('.WI_mobileQoptions_in').style.transform = 'translateY(300px)';
    mobileQuickOptionBody.querySelector('.WI_mobileQoptions_in').style.opacity = '0';
    setTimeout(() => {
        mobileQuickOptionBody.style.display = "none";
        document.querySelector('#WI_mobileQoptions_product').innerHTML = "";
    }, 210);
});
mobileQuickOptionBody.querySelector('.WI_mobileQoptions_in').addEventListener('click', (e)=>{
    e.stopPropagation();
});

//^^Mobile quick option fetching
async function fetchQuickProduct(productHandle) {
    let product = productHandle;
    try {
        let res = await fetch('/products/' + product + '?view=quickadd');
        let data = await res.text();
        let html_div = document.createElement('div');
        html_div.innerHTML = data;
        let html_dom = html_div.querySelector('#WI_quickAddProduct_main').innerHTML;
        document.querySelector('#WI_mobileQoptions_product').innerHTML = html_dom;
        openMobileQuickOption();
        productAddToCart();
        listningAddCartForm();
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

// Product Add to cart
function productAddToCart() {
    let mobileQuickAddButton = document.querySelectorAll('.WI_mobileQuickAdd_label');
    let mobileQuickAddInput = document.getElementsByClassName('WI_mobileQuickAdd');
    let mobileQuickOPtionBody = document.getElementById('WI_mobileQoptions_main');
    mobileQuickAddButton.forEach((varBtn) => {
        varBtn.addEventListener('click', () => {
            var mobileQuickAddInputValue = "";
            setTimeout(() => {
                for (let i = 0; i < mobileQuickAddInput.length; i++) {
                    if (mobileQuickAddInput[i].checked) {
                        mobileQuickAddInputValue += mobileQuickAddInput[i].value.toLowerCase().replace(" ", "").toString();
                    }
                }
            }, 10);
            //^^Parsing product json
            setTimeout(() => {
                let productJson = JSON.parse(mobileQuickOPtionBody.querySelector('[type="application/json"]').textContent);
                productJson.forEach(obj => {
                    let objTitle = obj.title.toLowerCase().replace(/[\\\s]/g, '');
                    let quickAddActive = document.getElementById('QuickAddAtcvariantinput');
                    if (mobileQuickAddInputValue == objTitle) {
                        console.log(quickAddActive);
                        quickAddActive.value = obj.id;
                    }
                });
            }, 20);
        });
    });
};

// Search
//^^search open
for (let i = 0; i < searchOpenBth.length; i++) {
    searchOpenBth[i].addEventListener('click', () => {
        searchBody.style.display = 'block';
        desktopHead.style.backgroundColor = "rgba(255,255,255,1)";
        headerSvgColorBlack();
        //^^ It keeps the header white cause now as soon as mouse leaves the header it goes bake to default color
        searchBody.addEventListener('mouseover', () => {
            desktopHead.style.backgroundColor = "rgba(255,255,255,1)";
            headerSvgColorBlack();
        });
    });
};
//^^Search close
searchCloseBth.addEventListener('click', () => {
    searchBody.style.display = 'none';
    console.log(window.scrollY);
    if (window.scrollY > 400) {
        desktopHead.style.backgroundColor = "rgba(255,255,255)";
        headerSvgColorBlack();
    } else {
        desktopHead.style.backgroundColor = "rgba(255,255,255,0)";
        console.log("work");
        headerSvgColorWhite();
    }
});
//^^Search opration
class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        //^^Search clear button
        searchClean.addEventListener('click', (event) => {
            searchInput.value = "";
            this.close(event);
            searchUpsell.style.display = 'flex';
            searchNumber.style.display = 'none';
        });

    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            searchUpsell.style.display = 'flex';
            searchNumber.style.display = 'none';
            return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.open();
                searchUpsell.style.display = 'none';
                searchNumber.style.display = 'block';
                searchNumber.innerText = 'View all results for ' + '"' + searchInput.value + '"';
                quickATCfunction();
                mobileQuickAdd();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }
    open() {
        this.predictiveSearchResults.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);

// Main search
const mainSearchInput = document.getElementById('WI_mainSearch');
    if (mainSearchInput != null) {
        mainSearchInput.addEventListener('input', debounce(()=>{
            let innputVal = document.getElementById('WI_mainSearch').value.trim();
            if (!innputVal.length) {
                searchEmpty();
            }else{
                mainSearchOperation(innputVal);
            }
            
            }), 500);
        
    }
    async function mainSearchOperation(searchTerm) {
        let res = await fetch(`/search?q=${searchTerm}&section_id=wi-mainsearch`);
        let txtData = await res.text();
        let html = document.createElement('div');
        html.innerHTML = txtData;
        let updatedSearch = html.querySelector('.WI_mainSearch_in').innerHTML;
        document.querySelector('.WI_mainSearch_in').innerHTML = updatedSearch;
        let newSearchUrl = `q=${searchTerm}&options%5Bprefix%5D=last`;
        history.replaceState(null, null, "?" + newSearchUrl.toString());
    }
    function searchEmpty() {
        let searchData = document.querySelector('.WI_mainSearch_in');
        searchData.innerHTML =  "";
        let newSearchUrl = `q=&options%5Bprefix%5D=last`;
        history.replaceState(null, null, "?" + newSearchUrl.toString());
    }

// Mobile menu
//^^Open mobile menu
mobileMenuOpen.addEventListener('click', () => {
    mobileMenuBody.style.display = 'flex';
    setTimeout(() => {
        mobileMenuBody.classList.add('addBlur');
        mobileMenuIn.classList.add('mobileMenuOut');
    }, 10);
});
//^^Close mobile menu
mobileMenuClose.addEventListener('click', () => {
    mobileMenuBody.classList.remove('addBlur');
    mobileMenuIn.classList.remove('mobileMenuOut');
    setTimeout(() => {
        mobileMenuBody.style.display = 'none';
    }, 310);
})
//^^close mobile menu when click outside
mobileMenuBody.addEventListener('click', (e) => {
    if (e.target == mobileMenuBody) {
        mobileMenuBody.classList.remove('addBlur');
        mobileMenuIn.classList.remove('mobileMenuOut');
        setTimeout(() => {
            mobileMenuBody.style.display = 'none';
        }, 310);
    }
})

//^^Open mobile menu LI 
mobileLI.forEach((LI) => {
    LI.addEventListener('click', (e) => {
        e.preventDefault();
        let accordionContent = LI.parentElement.querySelector('.FMchildUL');
        let accordionIcon = LI.querySelector('svg');
        if (accordionContent.style.maxHeight) {
            accordionContent.style.maxHeight = null;
            accordionContent.style.transform = 'scale(0)';
            accordionIcon.style.transform = 'rotate(0deg)';
        } else {
            accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
            accordionContent.style.transform = 'scale(1)';
            accordionIcon.style.transform = 'rotate(180deg)';
        }
    })
});

// Collection Page
if (collectionUL != null) {
    let collectionNextPageUrl = collectionUL.getAttribute('data-next-page-url');
    let isLoading = false; // To prevent multiple triggers
    let filterURL = "";
    let sortURL = "";
    //^^ Collection fetch filtering and sorting
    async function collectionFilterFetching() {
        let collectionFilterURL = new URLSearchParams(new FormData(collectionFilterForm)).toString();
        if (collectionFilterURL == "") {
            collectionFilterURL = collectionFilterURL;
            isLoading = false;
        }else{
            collectionFilterURL = collectionFilterURL+'&filter.v.availability=1';
        }
        try {
            let res = await fetch("?section_id=main-collection-product-grid" + "&" + collectionFilterURL);
            let data = await res.text();
            let html_div = document.createElement('div');
            html_div.innerHTML = data;
            let html_dom = html_div.querySelector('#WI_collectionUL').innerHTML;
            document.querySelector('#WI_collectionUL').innerHTML = html_dom;
            setTimeout(() => {
                let newNextPageUrl = html_div.querySelector('#WI_collectionUL').getAttribute('data-next-page-url');
                console.log(newNextPageUrl);
                
                // collectionUL.setAttribute('data-next-page-url', newNextPageUrl); // Update the URL
                collectionNextPageUrl = newNextPageUrl;
                history.replaceState(null, null, "?" + collectionFilterURL.toString());
                let filter_dom = html_div.querySelector('.WI_collectionFilter_in').innerHTML;
                document.querySelector('.WI_collectionFilter_in').innerHTML = filter_dom;
                let collectionProCount = html_div.querySelector('#collProductCount').innerHTML;
                document.querySelector('#collProductCount').innerHTML = collectionProCount;
            }, 100);
            quickATCfunction();
            mobileQuickAdd();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //^^ Collection filter open function
    function collectionFilterOpen() {
        collectionFilterBody.style.display = "flex";
        setInterval(() => {
            collectionFilterBody.classList.add = ('addBlur');
            collectionFilterDrawer.style.transform = "translateX(0)";
        }, 1);
    }
    //^^ Collection filter close function
    function collectionFilterClose() {
        collectionFilterBody.classList.remove = ('addBlur');
        collectionFilterDrawer.style.transform = "translateX(100%)";
        setTimeout(() => {
            collectionFilterBody.style.display = "none";
        }, 1);
    }
    //^^ When click on filter inputs
    function filterInputLoop() {
        collectionFilterForm.addEventListener('input', () => {
            collectionFilterFetching();
        })
    }
    filterInputLoop();
    //^^ When click on filter open btn
    collectionFilterOpenBtn.addEventListener('click', () => {
        collectionFilterOpen();
    });
    //^^ When click on filter submit button
    collectionFormSubmit.addEventListener('click', () => {
        collectionFilterClose();
    });
    //^^ When click on filter close btn
    collectionFilterCloseBtn.addEventListener('click', () => {
        collectionFilterClose();
    });
    //^^ When click on outside collection filter drawer
    collectionFilterBody.addEventListener('click', (e) => {
        if (e.target == collectionFilterBody) {
            collectionFilterClose();
        }
    });
    //^^ Collection infinit scroll
// Initialize the next page URL globally

let debounceTimeout; // Timeout variable for debouncing

async function collectionInfiniteLoad() {
    console.log(collectionNextPageUrl);
    console.log(isLoading);
    
    if (!collectionNextPageUrl || isLoading) {
        return; // Exit if there's no next page or if a load is already in progress
    }
    
    isLoading = true; // Set loading flag to true
    
    try {
        document.querySelector('.collection_infinit_scroll_loading').style.display = 'flex';
        let res = await fetch(collectionNextPageUrl);
        let data = await res.text();
        let html = document.createElement('div');
        html.innerHTML = data;
        let html_dom = html.querySelector('#WI_collectionUL').innerHTML;
        document.querySelector('#WI_collectionUL').innerHTML += html_dom;

        // Update the next page URL for subsequent requests
        collectionNextPageUrl = html.querySelector('#WI_collectionUL').getAttribute('data-next-page-url');
        
        if (!collectionNextPageUrl) {
            // If there's no more pages, remove the scroll event listener
            window.removeEventListener('scroll', debouncedScrollHandler);
        }

        // Call additional functions after content load
        document.querySelector('.collection_infinit_scroll_loading').style.display = 'none';
        quickATCfunction();
        mobileQuickAdd();
    } catch (error) {
        console.log("Error: " + error);
    } finally {
        isLoading = false; // Reset loading flag
    }
}

// Debounce function to limit the rate at which handleScroll is executed
function debounce(func, delay) {
    return function() {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => func.apply(this, arguments), delay);
    };
}

// Function to check scroll position and trigger loading
function handleScroll() {
    // Check if the user is near the bottom of the page (adjust threshold as needed)
    const scrollThreshold = 500; // Pixels from the bottom to trigger load
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.documentElement.scrollHeight;

    if (pageHeight - scrollPosition <= scrollThreshold) {
        collectionInfiniteLoad();
    }
}

// Debounce the scroll event handler with a 200ms delay
const debouncedScrollHandler = debounce(handleScroll, 200);

// Attach the debounced scroll event listener
window.addEventListener('scroll', ()=>{
    console.log("windowscroll");
    debouncedScrollHandler();
});


};

// Product Page
if (productMain != null) {
    //^^ Product image lazy load
    function productLazyLoad() {
        let imageLazy = document.querySelectorAll('.proLazyImage');

        function lazyProductIntersection(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    let lazyData = entry.target.getAttribute('data-srcset');
                    entry.target.srcset = lazyData;
                    observer.unobserve(entry.target);
                }
            });
        };
        let lazyProductOption = {
            root: null,
            rootMargin: '300px 0px',
            threshold: 0
        };
        const observer = new IntersectionObserver(lazyProductIntersection, lazyProductOption);
        imageLazy.forEach(img => {
            observer.observe(img);
        });
    };
    productLazyLoad();

    // Proddct floating ATC button
document.addEventListener("DOMContentLoaded", function () {
    const target = document.getElementById("ProductPageATC");
    let floatingATCButton = document.getElementById('WI_mainProductStickyAtc');
    if (target) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    floatingATCButton.classList.remove('WI_mainProductStickyAtcACTIVE');
                } else {
                    floatingATCButton.classList.add('WI_mainProductStickyAtcACTIVE');
                }
            });
        });

        observer.observe(target);
    } else {
        console.error("Element with ID 'ProductPageATC' not found.");
    }

    floatingATCButton?.addEventListener("click", function () {
            if (target) {
                target.scrollIntoView({
                    behavior: "smooth", // Smooth scrolling effect
                    block: "end", // Aligns to the top of the element
                });
            } else {
                console.error("Element with ID 'ProductPageATC' not found.");
            }
        });
});
}

// User Form
const userformSwitcher = document.querySelectorAll('.userFormSwitcher');
userformSwitcher.forEach(switcher => {
    switcher.addEventListener("click", (e) => {
        let userformSwitcher = document.querySelectorAll('.userFormSwitcher');
        userformSwitcher.forEach(swi => {
            swi.style.opacity = "0.5";
        });
        let switchDataAttri = switcher.getAttribute('data-useSwitch');
        if (switcher.textContent == 'log in') {
            switcher.style.opacity = "1";
        } else if (switcher.textContent == 'register') {
            switcher.style.opacity = "1";
        }
        userFormIdentify(switchDataAttri);
    })
});
//^^ user form identifier
function userFormIdentify(ID) {
    let forms = document.querySelectorAll('.userForm');
    forms.forEach(elem => {
        elem.style.display = "none";
        let formDataAttri = elem.getAttribute('data-userForm');
        if (formDataAttri == ID) {
            elem.style.display = "block";
        }
    });
};

// Product Page Product add to cart
//^^ Clicking on variant input
const productPageVairantLabel = document.querySelectorAll('.WI_productPageVariant_label');
productPageVairantLabel.forEach(lab => {
    lab.addEventListener('click', () => {
        let variantInputForloop = document.getElementsByClassName("WI_productPageVariant_input");
        var variantInputValue = "";
        requestAnimationFrame(() => {
            for (let i = 0; i < variantInputForloop.length; i++) {
                if (variantInputForloop[i].checked) {
                    variantInputValue += variantInputForloop[i].value.toLowerCase().replace(" ", "").toString();
                }
            }
            console.log(variantInputValue);
        });
        //^^ Working with product json to get variant id
        requestAnimationFrame(() => {
            // console.log(document.querySelector(".WI_buyNow"));
            let productJSON = JSON.parse(document.querySelector(".WI_buyNow").querySelector('[type="application/json"]').textContent);
            let productVariantInput = document.getElementById("ProductPageVariantFormInput");
            productJSON.forEach(obj => {
                let JSONtitle = obj.title.toLowerCase().replace(/[\\\s]/g, '');
                console.log(JSONtitle);
                if (variantInputValue == JSONtitle) {
                    productVariantInput.value = obj.id;
                    //^^ Product page change url
                    var changeProductURL = "?variant=" + obj.id;
                    setTimeout(() => {
                        history.replaceState(null, null, changeProductURL.toString());
                    }, 100);
                }
            });
        })
    })
});
// Cart drawer
//^^ Updating cart bubble
function bubbleUpdate() {
    let cartCount = Number(document.querySelector('[data-cartCount]').getAttribute('data-cartCount'));
    if (cartCount > 0) {
        document.querySelector('.WI_cart_btn_bubble').style.display = 'flex';
        document.querySelector('.WI_cart_btn_bubble').innerHTML = cartCount;
    }else{
        document.querySelector('.WI_cart_btn_bubble').style.display = 'none';
        document.querySelector('.WI_cart_btn_bubble').innerHTML = 0;
    }
}
bubbleUpdate();
//^^ Listning to add to cart form
function listningAddCartForm() {
    let atcForm = document.querySelectorAll('form[action="/cart/add"]');
    atcForm.forEach(foRm => {
        foRm.addEventListener('submit', async (e) => {
            e.preventDefault();
            //^^ Adding loading spiner on submit button
            let submitBtn = foRm.querySelector('button[type="submit"]');
            if (submitBtn.querySelector('.WI_mobileQuickOption_atc_value')) {
                submitBtn.querySelector('.WI_mobileQuickOption_atc_value').style.display = "none";
            }
            if (submitBtn.querySelector('.WI_mobileQuickOption_atc_loading')) {
                submitBtn.querySelector('.WI_mobileQuickOption_atc_loading').style.display = "block";
            }
            if (submitBtn.querySelector('.WI_productPage_atc_value')) {
                submitBtn.querySelector('.WI_productPage_atc_value').style.display = "none";
            }
            if (submitBtn.querySelector('.WI_productPage_atc_loading')) {
                submitBtn.querySelector('.WI_productPage_atc_loading').style.display = "block";
            }
            //^^ Adding product to cart using ajax
            await fetch("/cart/add", {
                method: "post",
                body: new FormData(foRm),
            });
            //^^ Closing mobile quickadd option
            mobileQuickOptionBody.classList.remove('addBlur');
            mobileQuickOptionBody.querySelector('.WI_mobileQoptions_in').style.transform = 'translateY(300px)';
            mobileQuickOptionBody.querySelector('.WI_mobileQoptions_in').style.opacity = '0';
            setTimeout(() => {
            mobileQuickOptionBody.style.display = "none";
            document.querySelector('#WI_mobileQoptions_product').innerHTML = "";
            }, 210);
            await updateCartDrawer();
            openCartDrawer();
            if (submitBtn.querySelector('.WI_productPage_atc_value')) {
                submitBtn.querySelector('.WI_productPage_atc_value').style.display = "block";
            }
            if (submitBtn.querySelector('.WI_productPage_atc_loading')) {
                submitBtn.querySelector('.WI_productPage_atc_loading').style.display = "none";
            }
        });
    });
};
listningAddCartForm();
//^^ Open cart on click
document.querySelector('.WI_cart_btn').addEventListener('click', () => {
    openCartDrawer();
})
//^^ Open cart drawer function
function openCartDrawer() {
    let cartBody = document.querySelector('.WI_cartDrawer_main');
    let cartDrawer = document.querySelector('.WI_cartDrawer_in');
    cartBody.style.display = 'block';
    setTimeout(() => {
        cartBody.classList.add('cartAddBlur');
        cartDrawer.classList.add('cartDrawerActive');
    }, 10);
};

//^^ Update cart drawer 
async function updateCartDrawer() {
    let res = await fetch("/?section_id=wi-cartdrawer");
    let text = await res.text();
    let html = document.createElement('div');
    html.innerHTML = text;
    let newCartDrawer = html.querySelector('.WI_cartDrawer_in').innerHTML;
    let cartCount = Number(html.querySelector('[data-cartCount]').getAttribute('data-cartCount'));
    document.querySelector('.WI_cartDrawer_in').innerHTML = newCartDrawer;
    if (cartCount > 0) {
        document.querySelector('.WI_cart_btn_bubble').style.display = 'flex';
        document.querySelector('.WI_cart_btn_bubble').innerHTML = cartCount;
    }else{
        document.querySelector('.WI_cart_btn_bubble').style.display = 'none';
        document.querySelector('.WI_cart_btn_bubble').innerHTML = 0;
    }
    allCartListners();
    quickATCfunction();
    mobileQuickAdd();
    await shippingCalculator();
    deliveryDateCalculator();
};

//^^ all cart eventlistners in one funtion 
function allCartListners() {
    // All closing cart listners
    //^^ Closing cart drawer
    let closeCart = document.querySelector('.WI_cartDrawer_cls');
    closeCart.addEventListener("click", () => {
        closeCartDrawer();
    });
    //^^ Closing cart drawer when click on the body
    let cartBody = document.querySelector('.WI_cartDrawer_main');
    let cartDrawer = document.querySelector('.WI_cartDrawer_in');
    cartBody.addEventListener('click', (e) => {
        closeCartDrawer();
    });
    cartDrawer.addEventListener('click', (e) => {
        e.stopPropagation();
    });
    //^^ Close cart drawer main function
    function closeCartDrawer() {
        let cartBody = document.querySelector('.WI_cartDrawer_main');
        let cartDrawer = document.querySelector('.WI_cartDrawer_in');
        cartBody.classList.remove('cartAddBlur');
        cartDrawer.classList.remove('cartDrawerActive');
        setTimeout(() => {
            cartBody.style.display = 'none';
        }, 210);
    };
    //^^ Cart quantity function
    //^^ Update quantity
    document.querySelectorAll('.WI_cartDrawer_quantity button').forEach((quantityBtn) => {
        quantityBtn.addEventListener('click', async () => {
            // Geting line item key
            let rootItemKey = quantityBtn.parentElement.parentElement.parentElement.getAttribute('data-itemKey');
            // Get the quantity
            let quantityInput = Number(quantityBtn.parentElement.querySelector('input').value);
            let quantityAddBtn = quantityBtn.classList.contains('WI_cartDrawer_plus');
            let newQuantity = quantityAddBtn ? quantityInput + 1 : quantityInput - 1;
            //^^ Cart item loading
            let cartLoder = quantityBtn.parentElement.parentElement.parentElement.querySelector('.WI_cartLoading');
            cartLoder.style.display = "block",
            cartLoder.classList.add('WI_cartLoadingActive');
            // Ajax update
            let responce = await fetch('/cart/update.js', {
                method: 'post',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    updates: {
                        [rootItemKey]: newQuantity
                    }
                })
            });
            let data = await responce.json();
            // Cart update
            await updateCartDrawer();
        })
    });
    //^^ Removing item
    document.querySelectorAll('.WI_cartRemove').forEach((removeBtn)=>{
        removeBtn.addEventListener('click', async (e)=>{
            e.preventDefault();
            // Geting line item key
            let rootItemKey = removeBtn.parentElement.parentElement.getAttribute('data-itemKey');
            //^^ Cart item loading
            let cartLoder = removeBtn.parentElement.parentElement.querySelector('.WI_cartLoading');
            cartLoder.style.display = "block",
            cartLoder.classList.add('WI_cartLoadingActive');
            // Ajax remove
            await fetch('/cart/update.js', {
                method: 'post',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    updates: {
                        [rootItemKey]: 0
                    }
                })
            });
            // Cart update
            await updateCartDrawer();
        });
    });
}
allCartListners();

// Cart free shipping calculator
async function shippingCalculator(data) {
    let shippingPrice = Number(document.getElementById('WI_cartDrawer_shippingValue').value);
    let shippingTxt = document.getElementById('WI_cartDrawer_shippingTxt');
    let shippingBar = document.getElementById('WI_cartDrawer_shippingProgress');
        let shippingRes = await fetch('/cart.js');
        let shippingData = await shippingRes.json();
        let cartPrice = shippingData.total_price / 100;
    if (cartPrice < shippingPrice) {
        let shippingPriceDiffer = shippingPrice - cartPrice;
        shippingPriceDiffer = (Math.round(shippingPriceDiffer * 100) / 100);
        console.log(shippingPriceDiffer);
        shippingTxt.innerHTML = "You need <strong style='color:rgba(0,0,0,1);'>"+shippingPriceDiffer+" kr.</strong> more for free shipping.";
        let shippingPercent = parseInt(cartPrice/shippingPrice*100);
	    shippingBar.style.width = shippingPercent+"%";
    }else{
        shippingTxt.innerHTML = "Congratulations! You've unlocked free shipping!";
        shippingBar.style.width = '100%';
    }
}
shippingCalculator();

// Product Description
    const proDes = document.querySelectorAll('.WI_proDes_accor_heading');
    proDes.forEach(des=>{
        des.addEventListener('click', ()=>{
            let desData = des.nextElementSibling;
            if (desData.style.maxHeight == "") {
                desData.style.maxHeight = desData.scrollHeight+"px";
            }else{
                desData.style.maxHeight = null;
            }
        })
    });

// Complementary product
    let complyURLCon = document.querySelector('.WI_comply_con');
    if (complyURLCon) {
        let complyURL = document.querySelector('.WI_comply_con').getAttribute('data-complyURL');
        let complyObserver = document.querySelector('.WI_comply_main');
        let complyForFetchData = document.querySelector('.WI_comply_con');
        const complyIntersection = async (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(complyObserver);
            
            let res = await fetch(complyURL);
            let textData = await res.text();
            let html = document.createElement('div');
            html.innerHTML = textData;
            let complyFeatchData = html.querySelector('.WI_comply_con');
            if (complyFeatchData && complyFeatchData.innerHTML.trim().length) {
                complyForFetchData.innerHTML = complyFeatchData.innerHTML;
              }
            quickATCfunction();
            mobileQuickAdd();
            
        };
        let observer = new IntersectionObserver(complyIntersection, {rootMargin: '0px 0px 100px 0px'});
        observer.observe(complyObserver);
    }



// delivery data calculation
function deliveryDateCalculator () {
    let delivertData = document.querySelectorAll('.WI_certifide_txt p');
delivertData.forEach(data=>{
    const today = new Date();
    const dayOfWeek = today.getDay(); // Get the current day of the week (0 for Sunday, 6 for Saturday)

    let deliveryMessage = "";

    if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        // Monday to Friday (1-5)
        deliveryMessage = "1-2 days";
    } else if (dayOfWeek === 0 || dayOfWeek === 6) {
        // Saturday and Sunday (0 and 6)
        deliveryMessage = "2-3 days";
    }

    // Display the message (for example, in an element with id 'delivery-info')
    data.innerText = deliveryMessage;
});
}
deliveryDateCalculator();

// FeatureSwitchCollection
    const collectionSwitcher = document.querySelectorAll('.collectionSwitcher');
    const theCollection = document.querySelectorAll('.WI_featureSwitchCollection_collectionCon');
    collectionSwitcher.forEach((switcher, index) => {
        if (index === 0) {
            switcher.classList.add('WI_collectionSwitcherActiv');
            switcher.style.fontWeight = '500';
        }
        switcher.addEventListener('click', (e)=>{
            collectionSwitcher.forEach(ele=>{
                ele.classList.remove('WI_collectionSwitcherActiv');
                switcher.style.fontWeight = '400';
            });
            theCollection.forEach(coll=>{
                coll.style.display = "none";
            })
            let switcherData = switcher.getAttribute('data-switchID');
            switcher.classList.add('WI_collectionSwitcherActiv');
            document.getElementById(switcherData).style.display = 'flex';
            });
    });